import { createSlot } from "lib/@components/slot/create-slot"

export const CopDocumentsTabActions = createSlot("CopDocumentsTabActions")
